import * as React from 'react'
import * as SeparatorPrimitive from '@radix-ui/react-separator'

import { cn } from '../../lib/utils'
import { Typography } from '..'

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  title,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot='separator-root'
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'relative bg-neutral-surface-dark shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    >
      {title && (
        <Typography
          size='xs'
          weight='regular'
          className='absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-neutral-surface-light px-xs text-neutral-surface-80'
        >
          {title}
        </Typography>
      )}
    </SeparatorPrimitive.Root>
  )
}

export { Separator }
